import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { errorCode, report } from './utils/errors';

// Ошибки вне React-дерева: шум Monaco гасим, остальное отправляем в журнал с кодом
window.addEventListener('error', (e) => {
  if (e.message === 'Script error.' || e.message === 'Canceled') {
    e.preventDefault();
    return;
  }
  report(errorCode(), e.error || e.message, { label: 'window.onerror' });
});
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && (e.reason.name === 'Canceled' || String(e.reason) === 'Canceled')) {
    e.preventDefault();
    return;
  }
  report(errorCode(), e.reason, { label: 'unhandledrejection' });
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
